import ContactForm from "../components/contact-form/contact-form.component";

const Contact = () => (
    <ContactForm />
)

export default Contact;